module.exports = __webpack_public_path__ + "static/media/promoters.60a0fe05.svg";